import { Component, ElementRef, HostBinding, HostListener, Input, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { PlIcon } from '@app/icon-library/icons';
import { RadioItem } from '@shared/models/step.model';
import { I18nService } from '@app/i18n';

@Component({
  selector: 'pl-radio-item',
  templateUrl: './radioItem.component.html',
  styleUrls: ['./radioItem.component.scss'],
})
export class RadioItemComponent implements ControlValueAccessor {
  @Input({ required: true }) public item: RadioItem | null = null;
  @Input({ required: true }) public name: string = '';
  @Input({ required: true }) public isLast: boolean = false;
  @Input({ required: true }) public isDisabled: boolean = false;

  public radioValue: string | null = null;

  private onChangeCallback!: (value: string | null) => void;
  private onTouchedCallback!: () => void;

  public readonly PlIcon: typeof PlIcon = PlIcon;

  @HostBinding('tabindex') public tabindex: number = 1;
  @HostListener('focus') public onFocus(): void {
    console.log('TONIO RadioItemComponent onFocus this.item=', this.item);
    // preventScroll: true because scroll is handled by directive plScrollToInvalidControlOnSubmit
    this.customRadio.nativeElement.focus({ preventScroll: true });
  }

  @ViewChild('customRadio', { read: ElementRef }) public customRadio!: ElementRef;

  constructor(
    @Optional() @Self() public controlDir: NgControl,
    private i18nService: I18nService,
  ) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    }
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  public writeValue(radioValueToWrite: string | null): void {
    if (radioValueToWrite !== undefined) {
      this.radioValue = radioValueToWrite;
    }
  }

  public onTouched(): void {
    if (this.onTouchedCallback) {
      this.onTouchedCallback();
    }
  }

  public onRadioChange(): void {
    this.emitChanges();
  }

  private emitChanges(): void {
    this.onChangeCallback(this.radioValue);
    this.onTouched();
  }

  public onKeyDownOnCheckmark(event: KeyboardEvent, item: RadioItem): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.radioValue = item.value;
      this.onRadioChange();
    }
  }
}
